import Navigation from '../../../routing/Navigation';
import { appRoutes } from '../../../routing/routes';
import { filterNavigation } from '../../../routing/access';
import {
  Typography,
  AppBar,
  Box,
  CssBaseline,
  Divider,
  IconButton,
  Toolbar,
  Drawer,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { getUser } from '../../../redux/usersRedux';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { IMGS_URL } from '../../../config';

const drawerWidth = 240;
const lngs = {
  en: { nativeName: 'EN', flag: '🇬🇧' },
  pl: { nativeName: 'PL', flag: '🇵🇱' },
};

function ResponsiveDrawer({ children }, props) {
  const { t, i18n } = useTranslation();
  const { window } = props;
  const [mobileOpen, setMobileOpen] = useState(false);
  const user = useSelector((state) => getUser(state));
  const navigate = useNavigate();
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const [choosen, setChoosen] = useState(false);

  const userSettings = [
    { href: '/access-management', label: 'Profile i dostęp' },
    { href: '/account', label: `${t('account.description')}` },
    { href: '/users', label: `${t('account.users')}` },
    { href: '/logout', label: `${t('account.logout')}` },
  ];

  const masterSetting = [
    {
      label: `${t('masterData.descriptionBeer')}`,
      subSetting: [
        { href: '/marka', label: `${t('masterData.brand')}` },
        { href: '/opakowanie', label: `${t('masterData.packages')}` },
        { href: '/beer', label: `${t('masterData.beerList')}` },
      ],
    },
    {
      label: `${t('masterData.desIncompatibilities')}`,
      subSetting: [
        { href: '/pochodzenie', label: `${t('masterData.origins')}` },
        { href: '/obszar', label: `${t('masterData.area')}` },
        { href: '/rodzaj', label: `${t('masterData.type')}` },
        { href: '/opis', label: `${t('masterData.description')}` },
        { href: '/dodatkowy-opis', label: `${t('masterData.additionalDes')}` },
        { href: '/przyczyny', label: `${t('masterData.reasons')}` },
      ],
    },
    {
      label: `${t('masterData.specification.title')}`,
      subSetting: [
        {
          href: '/specifications',
          label: `${t('masterData.specification.specificationList')}`,
        },
      ],
    },
    {
      label: `${t('masterData.mailing')}`,
      subSetting: [
        { href: '/odbiorcy', label: `${t('masterData.recipients')}` },
        { href: '/mailing-group', label: `${t('masterData.mailingGroup')}` },
      ],
    },
    {
      label: `${t('bins.bin')}`,
      subSetting: [{ href: '/bins', label: `${t('bins.binList')}` }],
    },
  ];

  const pz05Setting = [
    {
      href: '/pz05',
      label: `${t('pz05.listIncompatibilities')}`,
    },
    {
      href: '/add-pz05',
      label: `${t('pz05.addIncompatibility')}`,
    },
    {
      href: '/pz05/raport',
      label: `${t('pz05.reportPZ05')}`,
    },
  ];

  const pz04Setting = [
    {
      href: '/pz04',
      label: `${t('pz04.listIncompatibilities')}`,
    },
    {
      href: '/add-pz04',
      label: `${t('pz04.addIncompatibility')}`,
    },
    {
      href: '/pz04/raport',
      label: `${t('pz04.reportPZ04')}`,
    },
  ];

  const handleAction = (action) => {
    navigate(action);
  };

  const drawer = (
    <div style={{ background: '#C09A53 ', color: 'white' }}>
      <Toolbar>
        <Box
          sx={{
            display: { xs: 'flex', md: 'flex' },
            mr: 1,
            width: '100px',
            height: '100%',
          }}
        >
          <Box
            component="img"
            src={`${IMGS_URL}/logo.png`}
            alt="logo"
            sx={{ maxHeight: '100%', maxWidth: '100%' }}
          />
          <Box
            component="img"
            src={`${IMGS_URL}/AMBF_LOGO.png`}
            alt="logo"
            sx={{ maxHeight: '70%', maxWidth: '70%', ml: 1, cursor: 'pointer' }}
            onClick={() => handleAction('/')}
          />
        </Box>
        {/* <Typography sx={{ mt: 1, fontWeight: 700, fontSize: '25px' }}>
          AMBF
        </Typography> */}
      </Toolbar>
      <Divider />
      <Navigation
        items={filterNavigation(
          [
            { href: '/', label: 'Home' },
            { href: '/slider', label: 'Slider' },
            { href: '/dashboard', label: 'Dashboard' },
            { href: '/inventory-counting', label: 'Liczenie kroczące' },
            { href: '/production-handover', label: 'Przekazanie produkcji' },
            { href: '/mix-deliveries', label: 'Symulacje mix' },
            { href: '/bot-monitor', label: 'Status botów' },
            { href: '/delivery-stock-changes', label: 'Zmiany składu dostawy' },
            { href: '/transport-simulation', label: 'Symulacja pełnych palet' },
            {
              href: '/transport-stock',
              label: 'Zapas do symulacji transportów',
            },
            { label: t('pz05.description'), children: pz05Setting },
            { label: t('pz04.description'), children: pz04Setting },
            {
              label: 'MasterData',
              children: masterSetting.map(({ label, subSetting }) => ({
                label,
                children: subSetting,
              })),
            },
            ...(user.users
              ? [
                  {
                    label: `${user.users.firstName} ${user.users.lastName}`,
                    children: userSettings,
                  },
                ]
              : []),
          ],
          user.users,
          appRoutes,
        )}
        onNavigate={handleAction}
      />
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          width: '100%',
        }}
        onClick={() => setChoosen(!choosen)}
      >
        <div
          style={{
            height: '60px',
            position: 'relative',
            width: '144px',
          }}
        >
          {Object.keys(lngs).map((lng) => (
            <button
              key={lng}
              style={{
                cursor: 'pointer',
                display: 'block',
                height: '40px',
                position: 'absolute',
                opacity: choosen || i18n.resolvedLanguage === lng ? '1' : '0',
                zIndex: i18n.resolvedLanguage === lng ? '1' : '0',
                left:
                  lng === 'en' && choosen
                    ? '12px'
                    : lng === 'pl' && choosen
                    ? '60px'
                    : '48px',
                top: choosen ? '10px' : '0',

                transition: '0.76s',
                width: '40px',
                webkitTransition: '0.76s',
                background: 'transparent',
                border: 'none',
                fontSize: '40px',
              }}
              type="submit"
              onClick={() => i18n.changeLanguage(lng)}
            >
              {lngs[lng].flag}
            </button>
          ))}
        </div>
      </div>
    </div>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  if (user.users === null) {
    return (
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          margin: 'auto',
          width: {
            sm: `calc(100% - ${drawerWidth}px)`,
            md: '90%',
            lg: '90%',
            xl: '90%',
          },
        }}
      >
        <Toolbar />
        {children}
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: `${drawerWidth}px` },
        }}
      >
        {/* tutaj dodalem display none dla md */}
        <Toolbar
          sx={{ bgcolor: '#C09A53', display: { xs: 'flex', md: 'none' } }}
        >
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mt: 2, mr: 2, display: { sm: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
          <Box
            sx={{
              display: { xs: 'flex', md: 'none' },
              mt: 2,
              mr: 1,
              width: '100px',
              height: '100%',
            }}
          >
            <Box
              component="img"
              src={`${IMGS_URL}/logo.png`}
              alt="logo"
              sx={{ maxHeight: '100%', maxWidth: '100%' }}
            />
          </Box>
          <Typography
            sx={{ display: { xs: 'block', md: 'none' }, mt: 3 }}
            variant="h6"
            noWrap
            component="div"
          >
            AMBF
          </Typography>
        </Toolbar>
      </AppBar>
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="mailbox folders"
      >
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: drawerWidth,
            },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: 'none', sm: 'block' },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: drawerWidth,
            },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
      <Box
        component="div"
        sx={{
          flexGrow: 1,
          m: 'auto',
          p: 3,
          width: {
            sm: `calc(100% - ${drawerWidth}px)`,
            md: '90%',
            lg: '90%',
            xl: '90%',
          },
          // maxWidth: '100vw',
        }}
      >
        <Toolbar />

        {children}
      </Box>
    </Box>
  );
}

export default ResponsiveDrawer;
